import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { GuestAlertDashboardComponent } from './guest-alert-dashboard/guest-alert-dashboard.component';
import { ComposeAlertComponent } from './compose-alert/compose-alert.component';
import { SmsLogComponent } from '../sms-log/sms-log.component';
import { PMSRouteEnum } from '../../shared/enums/route.enum';
import { PMSPermissionEnum } from '../../shared/enums/permission.enum';
import { permissionGuard } from '../../shared/guards/auth/permission.guard';

const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./guest-alert-dashboard/guest-alert-dashboard.component').then(
        (c) => GuestAlertDashboardComponent,
      ),
    children: [
      {
        path: '',
        redirectTo: PMSRouteEnum.PMS_COMPOSE_ALERT,
        pathMatch: 'full',
      },
      {
        path: PMSRouteEnum.PMS_COMPOSE_ALERT,
        loadComponent: () =>
          import('./compose-alert/compose-alert.component').then(
            (c) => ComposeAlertComponent,
          ),
        canActivate: [permissionGuard],
        data: {
          permission: [PMSPermissionEnum.PMS_COMPOSE_ALERT],
        },
      },
      {
        path: PMSRouteEnum.PMS_SMS_LOG,
        loadComponent: () =>
          import('../sms-log/sms-log.component').then((c) => SmsLogComponent),
        canActivate: [permissionGuard],
        data: {
          permission: [PMSPermissionEnum.PMS_SMS_LOG],
        },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class GuestAlertRoutingModule {}
